<template>
<div>
    <body class="sidebar-fixed">    
        <div class="container-scroller">
            <div class="container-fluid page-body-wrapper full-page-wrapper">
                <div class="content-wrapper d-flex align-items-center auth px-0">
                    <div class="row w-100 mx-0">
                        <div class="col-lg-4 mx-auto">
                            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
                                <div class="brand-logo">
                                    <img src="../../../assets/images/logo.svg" alt="logo">
                                </div>
                                <div id="ContainerLogin" >
                                    <p class="text-muted">{{$t('AccessDenied.aDenied')}}</p>
                                </div>
                                <div id="ContainerButton" v-if="IsUserAuthenticated()" >
                                    <MdButton 
                                        v-bind:Label="$t('AccessDenied.GoTo')" 
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-block btn-primary btn-login btn-lg font-weight-medium auth-form-btn text-truncate'"
                                        v-on:click="GoToMainScreen()">
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>     
        </div> 
    </body>
</div>
</template>

<script>
import UserService from '@/services/user.service'

export default {
  name: 'AccessDenied',
  methods:{
    GoToMainScreen() {
        this.$router.push({name: "Main"});  
    },

    IsUserAuthenticated() {
        return UserService.IsAuthenticated();
    }
  }
   
};
</script>
<style>
.URLName{
  font-weight: bold;
  color:  #19BEE8;
  -webkit-font-smoothing: antialiased;
}
</style>
